import React, { useRef, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";

function FileDropzone({ onFiles, disabled = false, label = "Dosyaları sürükleyip bırakın veya seçmek için tıklayın" }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);

  const emit = (list) => {
    const files = Array.from(list || []);
    if (files.length && !disabled) onFiles(files);
  };

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={() => !disabled && inputRef.current?.click()}
      onKeyDown={(e) => {
        if (!disabled && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          inputRef.current?.click();
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        emit(e.dataTransfer?.files);
      }}
      className={`flex flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed px-4 py-5 text-sm text-center transition-colors ${
        disabled
          ? "border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed"
          : over
          ? "border-primary bg-primary/10 text-gray-700 cursor-pointer"
          : "border-gray-300 text-gray-500 hover:border-primary cursor-pointer"
      }`}
    >
      <FaCloudUploadAlt className="w-5 h-5" aria-hidden="true" />
      <span>{label}</span>
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        data-testid="dropzone-input"
        disabled={disabled}
        onChange={(e) => {
          emit(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}

export default FileDropzone;
